import React, { useEffect } from "react";
import AppLayout from "../components/app-layoout";
import { LayoutContainer } from "../components/app-layoout/container";
import {
  Box,
  Grid,
  Stack,
  Typography,
  styled,
  Divider,
  useTheme,
  Button,
} from "@mui/material";
import Iconify from "../components/iconify/iconify";
import HauseCarousel from "../components/PropertiesView/Hause-carousel/HauseCarousel";
import ModelsCarousel from "../components/PropertiesView/Models-carousel/ModelsCarousel";
import PropertyStats from "../components/PropertiesView/PropertyStats";
import Details from "../components/PropertiesView/Details";

import useWindowSize from "../hooks/useWindowSize";

import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { usePropertiesSlug } from "../hooks/use-data-properties";
import { PaymentWalletButton } from "../components/ButtonWalletPay";
import { formatMoney } from "../lib/formatMoney";
import { useAuthStore } from "../stores/authStore";
import { YooptaReadOnly } from "../components/Yoopta/YooptaReadOnly";

const StyledLocationBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: "5px 10px",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "10px",
  color: theme.palette.text.secondary,
}));

const StyledBorderStack = styled(Stack)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "8px",
  padding: "35px",
  [theme.breakpoints.down("sm")]: {
    padding: "15px",
  },
}));

const StyledKeyBox = styled(Box)(({ theme }) => ({
  background:
    "linear-gradient(90.00deg, rgb(26, 26, 26),rgba(26, 26, 26, 0) 100%)",
  display: "flex",
  alignItems: "center",
  padding: "7px 10px",
  color: theme.palette.text.secondary,
  borderLeft: `2px solid #a95052`,
  gap: "10px",
}));

const PropertiesView = () => {
  const theme = useTheme();
  const borderValue = `1px solid ${theme.palette.divider}`;
  const screenWidth = useWindowSize();
  const { auth } = useAuthStore();
  const navigate = useNavigate();
  let { slug } = useParams();

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (!searchParams.get("token")) return;
    auth.setAccessToken(searchParams.get("token"));
    navigate(`/propiedades/${slug}`);
  }, [searchParams]);

  const { dataPropertiesSlugQuery } = usePropertiesSlug(slug);

  if (!dataPropertiesSlugQuery.data) return <></>;

  return (
    <AppLayout>
      <LayoutContainer>
        <Stack
          direction="row"
          alignItems={{ xs: "flex-end", md: "center" }}
          justifyContent="space-between"
          pb={{ xs: "40px", md: "40px" }}
          pt={{ xs: "80px", md: "120px" }}
        >
          <Stack
            direction={{ xs: "column", md: "column" }}
            alignItems={{ xs: "start" }}
          >
            <Typography
              variant="h5"
              color="text.secondary"
              textTransform={"capitalize"}
              fontWeight={"bold"}
            >
              {dataPropertiesSlugQuery.data?.name
                ? dataPropertiesSlugQuery.data.name
                : ""}
            </Typography>
            <Typography
              variant="h6"
              color="text.secondary"
              textTransform={"capitalize"}
              fontSize={"0.9rem"}
            >
              {dataPropertiesSlugQuery.data?.city || ""}
            </Typography>
            {/*  <StyledLocationBox>
              <Iconify icon="carbon:location" />
              <Typography variant="body1" color="text.secondary">
                 {nameOfResidence}
              </Typography>
            </StyledLocationBox> */}
          </Stack>
          <Stack
            direction={{ xs: "column", md: "row" }}
            alignItems={{ xs: "start", md: "center" }}
            gap={2}
          >
            {!dataPropertiesSlugQuery.data.isNormal ? (
              <Stack direction="column" gap={1}>
                <Typography variant="h6" color="text.secondary">
                  Precio:{" "}
                  {formatMoney({
                    amount:
                      dataPropertiesSlugQuery.data.saleStage.find(
                        (stage) => stage.status === "ACTIVE"
                      )?.pricePerToken || 0,
                    symbol: "$ ",
                    append: false,
                  })}{" "}
                  USD
                </Typography>
                <PaymentWalletButton
                  propertyId={dataPropertiesSlugQuery.data.id}
                  onPaymentSuccess={() => {
                    console.log("pago completado");
                  }}
                  onWindowClosed={() => {
                    console.log("ventana cerrada");
                  }}
                >
                  Comprar
                </PaymentWalletButton>
              </Stack>
            ) : (
              <Stack direction="column" gap={1}>
                <Typography variant="h6" color="text.secondary">
                  Precios desde :{" "}
                </Typography>
                <Typography variant="h6" color="text.secondary">
                  {formatMoney({
                    amount: Number(dataPropertiesSlugQuery.data.price || "0"),
                    symbol: "$ ",
                    append: false,
                  })}
                  {"  "}
                  USD
                </Typography>
                <Typography variant="h6" color="text.secondary">
                  {formatMoney({
                    amount: Number(
                      dataPropertiesSlugQuery.data.priceMxn || "0"
                    ),
                    symbol: "$ ",
                    append: false,
                  })}
                  {"  "}
                  MXN
                </Typography>

                <Typography variant="h6" color="text.secondary">
                  {formatMoney({
                    amount: Number(dataPropertiesSlugQuery.data.price || "0"),
                    symbol: "$ ",
                    append: false,
                  })}
                  {"  "}
                  SOIL
                </Typography>
              </Stack>
            )}
          </Stack>
        </Stack>

        {!dataPropertiesSlugQuery.data.isNormal && (
          <PropertyStats data={dataPropertiesSlugQuery.data.dataSell} />
        )}
        <HauseCarousel
          imgData={dataPropertiesSlugQuery.data.carrouselImagesUrl || []}
        />

        <Grid container spacing={2} pb={{ xs: 3, md: 4 }}>
          <Grid item xs={12} md={6}>
            <StyledBorderStack direction="column" gap={1}>
              <Typography
                sx={{
                  fontSize: 20,
                  fontWeight: "bold",
                }}
                color="text.secondary"
              >
                {dataPropertiesSlugQuery.data?.description?.descripcionTitle ||
                  "Descripción"}
              </Typography>

              <YooptaReadOnly
                initValue={JSON.parse(
                  dataPropertiesSlugQuery?.data?.description?.descripcion ||
                    "{}"
                )}
              />

              {!!dataPropertiesSlugQuery.data?.description?.enseres && (
                <>
                  {" "}
                  <Divider variant="fullWidth" orientation="horizontal" />{" "}
                  <Stack
                    direction="row"
                    flexWrap={{ xs: "wrap", md: "nowrap" }}
                    pt={2}
                  >
                    {dataPropertiesSlugQuery.data?.description?.enseres.map(
                      (item, i, s) => {
                        if (i === 0) {
                          return (
                            <Stack
                              direction="column"
                              gap={1}
                              borderRight={borderValue}
                              pr={{ xs: 1, md: 0 }}
                              width={{ xs: "45%", md: "100%" }}
                            >
                              <Stack
                                direction="row"
                                alignItems="center"
                                gap={1}
                              >
                                <Iconify
                                  icon={item.icon}
                                  sx={{ color: "text.primary" }}
                                />
                                <Typography
                                  variant="body1"
                                  color="text.secondary"
                                >
                                  {item.descripcion}
                                </Typography>
                              </Stack>
                              <Typography
                                variant="subtitle2"
                                color="text.secondary"
                                pl="4px"
                              >
                                {item.count}
                              </Typography>
                            </Stack>
                          );
                        }
                        if (i === s.length - 1) {
                          return (
                            <Stack
                              direction="column"
                              gap={1}
                              borderRight={borderValue}
                              borderTop={{ xs: borderValue, md: "none" }}
                              width={{ xs: "45%", md: "80%" }}
                              pl={{ xs: 0, md: 2 }}
                              pt={{ xs: 2, md: 0 }}
                              pr={{ xs: 1, md: 0 }}
                              mt={screenWidth < 1000 ? 2 : 0}
                            >
                              <Stack
                                direction="row"
                                alignItems="center"
                                gap={1}
                              >
                                <Iconify
                                  icon={item.icon}
                                  sx={{ color: "text.primary" }}
                                />
                                <Typography
                                  variant="body1"
                                  color="text.secondary"
                                >
                                  {item.descripcion}
                                </Typography>
                              </Stack>
                              <Typography
                                variant="subtitle2"
                                color="text.secondary"
                                pl="4px"
                              >
                                {item.count}
                              </Typography>
                            </Stack>
                          );
                        }

                        return (
                          <Stack
                            direction="column"
                            gap={1}
                            borderRight={{ xs: "none", md: borderValue }}
                            width={{ xs: "45%", md: "80%" }}
                            pl={2}
                            pb={{ xs: 2, md: 0 }}
                          >
                            <Stack direction="row" alignItems="center" gap={1}>
                              <Iconify
                                icon={item.icon}
                                sx={{ color: "text.primary" }}
                              />
                              <Typography
                                variant="body1"
                                color="text.secondary"
                              >
                                {item.descripcion}
                              </Typography>
                            </Stack>
                            <Typography
                              variant="subtitle2"
                              color="text.secondary"
                              pl="4px"
                            >
                              {item.count}
                            </Typography>
                          </Stack>
                        );
                      }
                    )}
                  </Stack>
                </>
              )}
              <Box flex={1} display="flex" gap={2} mt={2} justifyContent="center">
                {!!dataPropertiesSlugQuery.data?.linkProject && (
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#a95052",
                      lineHeight: { md: "1.2", xl: "1.75" },
                      paddingX: { xs: "7px", md: "15px", xl: "20px" },
                      "&:hover": { backgroundColor: "#8c3e47" },
                    }}
                    onClick={() => {
                      window.open(dataPropertiesSlugQuery.data.linkProject);
                    }}
                  >
                    Ver sitio del proyecto
                  </Button>
                )}

                {!!dataPropertiesSlugQuery.data?.externalVideoLink && (
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#a95052",
                      lineHeight: { md: "1.2", xl: "1.75" },
                      paddingX: { xs: "7px", md: "15px", xl: "20px" },
                      "&:hover": { backgroundColor: "#8c3e47" },
                    }}
                    onClick={() => {
                      window.open(dataPropertiesSlugQuery.data.externalVideoLink);
                    }}
                  >
                    Ver video
                  </Button>
                )}
              </Box>
            </StyledBorderStack>
            
          </Grid>

          <Grid item xs={12} md={6}>
            <StyledBorderStack direction="column" gap={2}>
              <Typography
                sx={{
                  fontSize: 20,
                  fontWeight: "bold",
                }}
                color="text.secondary"
              >
                {dataPropertiesSlugQuery.data?.descriptionList
                  ?.descripcionTitle || "Detalles de interiores:"}
              </Typography>
              {(dataPropertiesSlugQuery.data?.descriptionList?.list || []).map(
                (text, index) => (
                  <StyledKeyBox key={index}>
                    <Iconify icon="ph:lightning-fill" />
                    <Typography
                      sx={{
                        fontSize: 17,
                      }}
                      color="white"
                    >
                      {text}
                    </Typography>
                  </StyledKeyBox>
                )
              )}
            </StyledBorderStack>
          </Grid>
        </Grid>

        <ModelsCarousel
          modelsData={
            dataPropertiesSlugQuery.data.carrouselModelImagesUrl || []
          }
        />
        {/*  <FormPage /> */}
        <Details data={dataPropertiesSlugQuery.data} />
        {/*    <AskedQuestionCarousel /> */}
      </LayoutContainer>
    </AppLayout>
  );
};

export default PropertiesView;
